module.exports = __webpack_public_path__ + "static/media/blinko-blanco.2951d92b.png";